import { useState, useEffect } from "react";

import { get } from "library/endpoints";

/**
 * useUserIris
 * @returns 
 */
export default function useUserIris() {
  const [userIris, setUserIris] = useState([]);

  useEffect(() => {
    fetchUserIris();
  }, []) // eslint-disable-line

  const fetchUserIris = async () => {
    try {
      const {data} = await get('/frontend/shootings')      
      setUserIris(data)
    } catch (err) {
      console.log(err)
    }
  }

  return {
    userIris,
    fetchUserIris
  }
}